import { render, staticRenderFns } from "./KnowledgeBaseTypeEditDialog.vue?vue&type=template&id=5b1f1126"
import script from "./KnowledgeBaseTypeEditDialog.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseTypeEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports